import React from 'react';
import '../../styles/accueil/Confidentialite.css';

function Confidentialite() {
  return (
    <div className="confidentialite-container">
      <h1>POLITIQUE DE CONFIDENTIALITÉ</h1>

      <h2>🔒 Pour les acheteurs – Version française</h2>
      <ol>
        <li><strong>Qui sommes-nous ?</strong><br />
          Tsenan’ny Tantsaha est une plateforme de vente directe entre producteurs agricoles et acheteurs à Madagascar.
        </li>

        <li><strong>Données collectées</strong><br />
          - Nom, prénom<br />
          - Numéro de téléphone<br />
          - Adresse de livraison<br />
          - E-mail (si fourni)<br />
          - Mode de paiement (MVola, Orange Money)
        </li>

        <li><strong>Utilisation des données</strong><br />
          Vos données servent uniquement à : livrer la commande, vous contacter et améliorer notre service.
        </li>

        <li><strong>Partage des données</strong><br />
          Les données sont partagées uniquement avec :<br />
          - Le producteur qui prépare votre commande<br />
          - Le livreur<br />
          Nous ne revendons jamais vos données.
        </li>

        <li><strong>Sécurité</strong><br />
          Nous protégeons vos données avec des accès sécurisés et des systèmes fiables.
        </li>

        <li><strong>Durée de conservation</strong><br />
          Vos données sont conservées pendant 12 mois maximum pour le suivi client.
        </li>

        <li><strong>Vos droits</strong><br />
          Vous pouvez nous contacter à tout moment pour modifier ou supprimer vos données :<br />
          contact@tsenannytantsaha.mg
        </li>

        <li><strong>Cookies</strong><br />
          Le site utilise des cookies uniquement pour le panier et la navigation. Aucun cookie publicitaire.
        </li>

        <li><strong>Mise à jour</strong><br />
          Dernière mise à jour : ___ / ___ / 202_
        </li>
      </ol>

      <h2>🔒 Ho an'ny mpividy – Malagasy</h2>
      <ol>
        <li><strong>Iza izahay ?</strong><br />
          Tsenan’ny Tantsaha dia sehatra manampy ireo tantsaha hivarotra mivantana amin'ny mpividy eto Madagasikara.
        </li>

        <li><strong>Antontan-kevitra angonina</strong><br />
          - Anarana sy fanampiny<br />
          - Nomeraon-telefaona<br />
          - Adiresy fanaterana<br />
          - Adiresy mailaka (raha misy)<br />
          - Fomba fandoavana (MVola, Orange Money)
        </li>

        <li><strong>Fampiasana azy</strong><br />
          Ampiasaina amin’ny fanaterana entana, fifandraisana, sy fanatsarana ny serivisy.
        </li>

        <li><strong>Izay mahazo miditra amin’izany</strong><br />
          - Mpivarotra manomana ny baikonao<br />
          - Mpitondra entana manatitra azy<br />
          Tsy zaraina amin'olona hafa na amin'ny dokam-barotra.
        </li>

        <li><strong>Fiambenana</strong><br />
          Arovanay amin'ny fomba ara-teknika sy ara-pitantanana ny angon-drakitrao.
        </li>

        <li><strong>Fitehirizana</strong><br />
          Tehirizina mandritra ny 12 volana farafahabetsany, amin’ny fikarakarana mpanjifa.
        </li>

        <li><strong>Zon'ny mpampiasa</strong><br />
          Afaka mangataka fanovana na famafana angona ianao amin’ny alalan’ny :<br />
          contact@tsenannytantsaha.mg
        </li>

        <li><strong>Cookies</strong><br />
          Mampiasa cookies ho an’ny fivarotana sy fitetezana ihany. Tsy misy cookies doka.
        </li>

        <li><strong>Fanavaozana</strong><br />
          Nohavaozina tamin’ny : ___ / ___ / 202_
        </li>
      </ol>
    </div>
  );
}

export default Confidentialite;
